import { Component, OnInit, OnDestroy } from '@angular/core';

import { forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

    user: any;

    value: any;

    constructor(
        private alertService: AlertService,
        private loginService: LoginService,
        private progressIndicatorService: ProgressIndicatorService
    ) {
    }

    ngOnInit() {
        this.progressIndicatorService.progress = true;
        this.loginService.getWhoamiV2().pipe(switchMap((data: any) => {
            let accountId = data.accountId;
            return forkJoin([
                of(data),
                this.loginService.getAccountByAccountIdV2(accountId),
                this.loginService.getProfileByAccountIdV2(accountId),
                this.loginService.getJwtV1()
            ]);
        })).subscribe({
            next: ([whoami, account, profile, jwt]) => {
                console.log('HomeComponent.ngOnInit.loginService.getWhoamiV2.value', whoami);
                console.log('HomeComponent.ngOnInit.loginService.getAccountByAccountIdV2.value', account);
                console.log('HomeComponent.ngOnInit.loginService.getProfileByAccountIdV2.value', profile);
                console.log('HomeComponent.ngOnInit.loginService.getJwtV1.value', jwt);
                this.progressIndicatorService.progress = false;
                this.user = {
                    firstName: profile.firstname,
                    lastName: profile.lastname,
                    email: account.email
                };
                this.value = JSON.stringify([whoami, account, profile, jwt], null, 2);
            },
            error: (error: any) => {
                console.log('HomeComponent.ngOnInit.loginService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    ngOnDestroy() {
    }
}
